import React, { useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import TestimonialsBox from "./TestimonialBox";
import clientA from "../../assets/images/Reviews/clientA.JPG";
import clientB from "../../assets/images/Reviews/clientB.JPG";
import clientC from "../../assets/images/Reviews/clientC.JPG";
import clientD from "../../assets/images/Reviews/clientD.jpg";
import clientE from "../../assets/images/Reviews/clientE.jpg";
import clientF from "../../assets/images/Reviews/clientF.jpeg";
import clientG from "../../assets/images/Reviews/clientG.jpeg";
import clientH from "../../assets/images/Reviews/clientH.jpg";
import clientJ from "../../assets/images/Reviews/clientJ.jpeg";

function Testimonials() {
    const { t } = useTranslation();
    const testimonialsData = [
        { id: 'r1', name: 'Isabelle, 53',
            description: `“Säit engem gudde Joer maachen ech lo Kraafttraining; antëscht gehéiert en fest zu mengem Alldag. D'Trainingsziler goufen zesummen ausgeschafft, an déi ofwiesslungsräich Exercicer loossen sech gutt mat mengem Ausdauersport kombinéieren a perfekt a mäin Alldag integréieren. Laang war ech mat Réckwéi a muskuläre Problemer geplot - dat huet sech immens gebessert! D'Gelenker wéi, wéinst der Menopause, hunn ech kaum méi! Ech si méi beweeglech ginn, mäi Kierper méi straff a meng Muskele méi definéiert - ech fille mech richteg gutt!”`,
            image: clientA },
        { id: 'r2', name: 'Marco, 82',
            description: `"Bonjour Sven,
                J'ai longtemps hésité avant de faire appel à tes services en tant que coach privé, mais aujourd'hui je dois dire que c'est une des meilleures décisions que j'ai prises ces derniers temps.
                Je suis devenu un autre homme tant sur plan physique que sur le plan moral. Je me sens de nouveau en pleine forme et bien dans ma peau.
                Un grand bravo pour ta compétence professionnelle."`,
            image: clientH },
        { id: 'r3', name: 'Christiane, 76',
            description: `"Ech sinn Dir sou dankbar vun seit mir regelméisseg trainéieren sinn ech mental a kierperlech  vill méi stark a flénk a glëcklech. E grousse merci un Dech."`,
            image: clientC },
        { id: 'r4', name: 'Isabelle, 74',
            description: `"En seulement 10 séances de 45 minutes avec Sven, mes enfants ont remarqué un très gros progrès dans ma stature et ma silhouette. Quelle joie! Quelle performance! MERCI à Sven pour:
                - son savoir
                - son écoute de ce que attend son élève d'un tel entraînement
                - sa réflexion et son adaptation aux problèmes personnels de son élève
                - son choix d'exercices sans cesse renouvelé
                - sa gentillesse et sa considération
                Je suis aujourd'hui très heureuse d'avoir trouvé enfin le bon coach et une bonne forme pour affronter avec sérénité les épreuves de l'âge."`,
            image: clientJ },
        { id: 'r5', name: 'Joëlle, 59',
            description: `“Vu mir hei mol en decken MERCI!! Dank dir hunn ech et fäerdeg bruecht, Gewiicht ze verléieren, Muskelen opzubauen, konsequent a mengem Training ze si an e gesonde Liewensstil unzehuelen. Ech si Haut méi fit wei jee a fill mech kierperlech a mental immens wuel. Ech freeë mech, weider mat dir ze trainéieren a weider Fortschrëtter ze maachen! ”`,
            image: clientB },
        { id: 'r6', name: 'Patricia, 46',
            description: `"I had a wonderful experience training with Sven. My 14-year-old son and I joined the program together, and Sven did an amazing job guiding us both. He was especially attentive with my son, making sure he learned how to do the exercises safely and with confidence. Beyond the workouts, Sven created a welcoming and encouraging environment that made the sessions fun and meaningful. It also gave me the chance to enjoy some really special quality time with my son. I'm very grateful for his support and highly recommend him as a trainer!"`,
            image: clientE },
        { id: 'r7', name: 'Viviane, 54',
            description: `"Sven ist seit fast zwei Jahren mein Personaltrainer, und ich bin sehr zufrieden mit seiner Betreuung. Seitdem ich mit ihm trainiere, habe ich meine Fitness und Beweglichkeit deutlich verbessert. Sein Trainingsprogramm ist individuell auf mich abgestimmt, und er betrachtet den Menschen als Ganzes. Das bedeutet, es geht nicht nur um Bewegung, sondern auch um gesunde Ernährung und die Einhaltung notwendiger körperlicher Pausen - nur um einige Beispiele zu nennen.\nBei Schwierigkeiten oder spezifischen Wünschen, wie etwa der Vorbereitung auf den Skiurlaub, passt er die Übungen gezielt an. Wir sind über Video-Call in Kontakt, und obwohl ich anfangs skeptisch war, muss ich sagen, dass dies hervorragend funktioniert. Während der Trainingseinheiten führt man die Übungen gemeinsam mit ihm durch, und er korrigiert einen, wenn man sie nicht korrekt ausführt. Alle Fragen werden stets ausführlich beantwortet.\nIch kann Sven uneingeschränkt weiterempfehlen."`,
            image: clientD },
        { id: 'r8', name: 'Anne Marie, 64',
            description: `"Duerch eng schlecht an kromm Haltung vun mengem Reck(déi sech trotz méintelanger Kiné net verbessert huet), an engem Muskelverloscht duerch keen Sport, ausser Laafband, hun ech mech schlecht gespiert. Souguer mengem Entourage ass et aufgefall an huet mir et och gesoot. Duerch e puren Zoufall hun ech vun NevskiFit héieren an hien kontaktéiert. De Sven huet mir e Program opgesaat. Hien hëllt sech vill Zait an Gedold fir engem d'Übungen ze erklären an leed vill Wärt drop, dass des och genau ausgeféiert gin, an get sech och vill Méi seng Stonnen ofwéisselungsréich ze gestallten, waat engem d'Sach méi flott an interressant mecht.
                Elo no 4 Méint intensivem Krafttraining an e bëssen Boxtraining fillen ech mech erem méi fit, motivéiert an et mecht mir Spass, souguer um boxen hun ech Freed fond, deen zousättslech zum Laafband e gudden Cardiotraining ass. Ech haalen mech duerch meng gestärkten Reckenmuskulatur erem méi riecht an fillen mech besser. Meng Frënn an zemols meng Duechter machen mir Komplimenter iwert meng zereckgewonnen Silouhette an meng muskléiert Ärm. Mir geet et erem gudd, sin zefridden an freeën mech op meng nächst Trainings-stonn."`,
            image: clientF },
        { id: 'r9', name: 'Monique, 88',
            description: `"Hallo Sven wollt der emol merci soen, dass de mir schon eso gut geholef hues seit mir zesumme schaffen kann ech besser goen well mein Ekiliber a meng Otmung sech vill verbessert hun och Trappe kann ech erem besser goen. Decke merci"`,
            image: clientG },
    ];

    // Show 3 testimonials initially for a better variety of stories
    const [visibleCount, setVisibleCount] = useState(3);
    const sectionRef = useRef(null);
    const collapseHeightRef = useRef(null);

    const handleShowMore = () => {
      // Show 3 more testimonials
      setVisibleCount((prev) => Math.min(prev + 3, testimonialsData.length));
    };

    const handleShowLess = () => {
      // Record the section's height before it shrinks so the layout
      // effect below can hold the viewport steady on the button instead
      // of letting the page silently scroll into the section below.
      collapseHeightRef.current = sectionRef.current?.offsetHeight ?? null;
      setVisibleCount((prev) => Math.max(prev - 3, 3));
    };

    useLayoutEffect(() => {
      if (collapseHeightRef.current == null || !sectionRef.current) return;
      const heightDiff = collapseHeightRef.current - sectionRef.current.offsetHeight;
      collapseHeightRef.current = null;
      if (heightDiff > 0) {
        window.scrollBy(0, -heightDiff);
      }
    }, [visibleCount]);

    return (
        <section ref={sectionRef} className="bg-[#162E3B] py-16 lg:py-24 border-t border-[#FFD82D]/10">
            <div className="max-w-4xl mx-auto px-6 lg:px-12">
                
                {/* Section Header */}
                <div className="text-center mb-12">
                  <h2 className="text-xl sm:text-2xl font-extrabold text-white mb-4">
                      {t('home.testimonials.title')}
                  </h2>
                </div>

                {/* Testimonial List */}
                <div className="flex flex-col gap-8">
                    {testimonialsData.slice(0, visibleCount).map((item, index) => (
                    <TestimonialsBox
                        key={index}
                        name={item.name}
                        description={item.description}
                        translatedDescription={t(`home.testimonials.reviews.${item.id}`)}
                        image={item.image}
                    />
                    ))}
                </div>

                {/* Show More / Show Less Buttons */}
                <div className="text-center mt-12 flex justify-center gap-4">
                  {visibleCount > 3 && (
                      <button
                        onClick={handleShowLess}
                        className="px-6 py-3.5 bg-transparent border-2 border-white/20 hover:border-[#FFD82D] hover:text-[#FFD82D] text-white font-extrabold rounded-xl text-base transition-all duration-200 active:scale-98 focus:outline-none"
                      >
                        {t('home.testimonials.showLess')}
                      </button>
                  )}

                  {visibleCount < testimonialsData.length && (
                      <button
                        onClick={handleShowMore}
                        className="px-6 py-3.5 bg-[#FFD82D] text-[#162E3B] hover:bg-white hover:text-black font-extrabold rounded-xl border-2 border-transparent text-base transition-all duration-200 shadow-md active:scale-98 focus:outline-none focus:ring-4 focus:ring-[#FFD82D]"
                      >
                        {t('home.testimonials.showMore')}
                      </button>
                  )}
                </div>
            </div>
        </section>
    );
}

export default Testimonials;
